export default __webpack_public_path__ + "static/select-template-7a2af39a6d2290dd469bc5db2355a4b8.jpg";